export const ARBITRAGE = '0x62B3B1C93Bbd5BBD4afC79433d2cD6Bf04b300BE';

export const ARBITRAGE_ABI =
	[
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "_from",
					"type": "address"
				},
				{
					"indexed": true,
					"internalType": "address",
					"name": "_to",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "_tokenIn",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "_amount",
					"type": "uint256"
				},
				{
					"internalType": "address",
					"name": "_tokenOut",
					"type": "address"
				},
				{
					"internalType": "address",
					"name": "router1",
					"type": "address"
				},
				{
					"internalType": "address",
					"name": "router2",
					"type": "address"
				}
			],
			"name": "createTradeAaveBot",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address[]",
					"name": "_values",
					"type": "address[]"
				},
				{
					"internalType": "uint256[]",
					"name": "_numbers",
					"type": "uint256[]"
				},
				{
					"internalType": "uint8[]",
					"name": "_exchRoute",
					"type": "uint8[]"
				}
			],
			"name": "createTradeBot",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"internalType": "address payable",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address payable",
					"name": "_newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		}
	]





export const AAVE_ARBITRAGE = '0xc26A7B249ed927544A47982bf8053FCe953ecc50'; //0x4e5358265c87287037d37B02158e7DC8D7585d34';

export const AAVE_ABI = [
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "_from",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "_to",
				"type": "address"
			}
		],
		"name": "OwnershipTransferred",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "_tokenIn",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "_amount",
				"type": "uint256"
			},
			{
				"internalType": "address",
				"name": "_tokenOut",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "router1",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "router2",
				"type": "address"
			}
		],
		"name": "createTradeAaveBot",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address[]",
				"name": "_values",
				"type": "address[]"
			},
			{
				"internalType": "uint256[]",
				"name": "_numbers",
				"type": "uint256[]"
			},
			{
				"internalType": "uint8[]",
				"name": "_exchRoute",
				"type": "uint8[]"
			}
		],
		"name": "createTradeBot",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "owner",
		"outputs": [
			{
				"internalType": "address payable",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address payable",
				"name": "_newOwner",
				"type": "address"
			}
		],
		"name": "transferOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	}
]
